import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { EActiveView } from '../../types/view';
import { EKeyCode } from '../../types/keyCodes';
import { ViewContainer } from '../ViewContainer';
import { TitleContainer } from '../TitleContainer';
import { EAlignment, FormFieldHelper } from '../../components/FormFieldHelper';
import { ContentLayout } from '../../components/ContentLayout';
import { PasswordField } from '../../components/PasswordField';
import { Link } from '../../components/Link';
import { FormFieldGroupLayout } from '../../components/FieldGroupLayout';
import { SubtitleLayout } from '../../components/SubtitleLayout';
import { trackForgotPasswordClick, trackLoginAnotherWay, trackLoginNeedHelp, trackShowConfirmAccount } from '../../utils/tracking';
import { InputField } from '../../components/InputField';
import { EAuthenticateByTokenStatus } from '../../types/phoneAuth';
import { HelpContainer } from '../HelpContainer';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function ConfirmAccountView(_ref) {
  var status = _ref.status,
    email = _ref.email,
    error = _ref.error,
    source = _ref.source,
    changeView = _ref.changeView,
    authenticateByToken = _ref.authenticateByToken;
  var isSubmitting = status === EAuthenticateByTokenStatus.Loading;
  var hasError = status === EAuthenticateByTokenStatus.Failed;
  // FORM
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    changed = _React$useState2[0],
    setChanged = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    touched = _React$useState4[0],
    setTouched = _React$useState4[1];
  // PASSWORD
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    password = _React$useState6[0],
    setPassword = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isInvalid = _React$useState8[0],
    setInvalid = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    passwordShown = _React$useState10[0],
    setPasswordShown = _React$useState10[1];
  var togglePasswordVisibility = React.useCallback(function () {
    return setPasswordShown(!passwordShown);
  }, [passwordShown]);
  var handlePasswordChange = React.useCallback(function (e) {
    var value = e.currentTarget.value;
    setPassword(value);
    setChanged(true);
    setInvalid(!value);
  }, []);
  var handleForgotPasswordClick = function handleForgotPasswordClick(event) {
    event.preventDefault();
    trackForgotPasswordClick(source);
    changeView(EActiveView.Restore, {
      email: email
    });
  };
  var handleSubmit = React.useCallback(function () {
    setTouched(true);
    if (isInvalid) {
      return;
    }
    setChanged(false);
    authenticateByToken({
      email: email || '',
      password: password
    });
  }, [authenticateByToken, email, isInvalid, password]);
  var switchView = function switchView() {
    trackLoginAnotherWay(source);
    changeView(EActiveView.AccountSelect);
  };
  var handlePreventSubmit = React.useCallback(function (e) {
    e.preventDefault();
  }, []);
  var handleSubmitOnEnter = React.useCallback(function (e) {
    if (e.keyCode === EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  var handleHelpClick = React.useCallback(function () {
    return trackLoginNeedHelp(source);
  }, [source]);
  React.useEffect(function () {
    trackShowConfirmAccount(source);
  }, []);
  return /*#__PURE__*/_jsxs(ViewContainer, {
    children: [/*#__PURE__*/_jsx(TitleContainer, {}), /*#__PURE__*/_jsxs(SubtitleLayout, {
      children: ["\u0414\u043B\u044F \u0432\u0445\u043E\u0434\u0430 \u0432 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 ", /*#__PURE__*/_jsx("b", {
        children: email
      }), " \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C"]
    }), /*#__PURE__*/_jsx(ContentLayout, {
      children: /*#__PURE__*/_jsx("form", {
        onSubmit: handlePreventSubmit,
        "data-testid": "ConfirmAccountForm",
        children: /*#__PURE__*/_jsx(FormFieldGroupLayout, {
          content: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(InputField, {
              "data-name": "LoginInput",
              name: "login",
              value: email,
              hidden: true,
              disabled: true
            }), /*#__PURE__*/_jsx(PasswordField, {
              autoFocus: true,
              id: "confirm-account-password",
              name: "password",
              placeholder: "\u041F\u0430\u0440\u043E\u043B\u044C",
              invalid: touched && (hasError && !changed || isInvalid),
              errorMessage: touched && hasError ? error : undefined,
              value: password,
              onChange: handlePasswordChange,
              onKeyDown: handleSubmitOnEnter,
              disabled: isSubmitting,
              passwordShown: passwordShown,
              toggleVisibility: togglePasswordVisibility
            }), /*#__PURE__*/_jsx(FormFieldHelper, {
              alignment: EAlignment.Right,
              marginBottom: true,
              children: /*#__PURE__*/_jsx(Link, {
                href: "#",
                onClick: handleForgotPasswordClick,
                children: "\u0417\u0430\u0431\u044B\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?"
              })
            })]
          }),
          buttons: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Button, {
              "data-name": "LoginBtn",
              theme: "fill_primary",
              fullWidth: true,
              disabled: isSubmitting,
              loading: isSubmitting,
              onClick: handleSubmit,
              children: "\u0412\u043E\u0439\u0442\u0438"
            }), /*#__PURE__*/_jsx(Button, {
              "data-name": "BackToAccountSelectBtn",
              fullWidth: true,
              theme: "fill_secondary",
              onClick: switchView,
              children: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442"
            })]
          })
        })
      })
    }), /*#__PURE__*/_jsx(HelpContainer, {
      onClick: handleHelpClick
    })]
  });
}